import { AfterViewInit, Component, signal, WritableSignal } from '@angular/core';
import { FirebaseError } from '@angular/fire/app';
import { sendEmailVerification } from '@angular/fire/auth';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { BaseComponent } from '../shared/base.component';
import { SiteHeaderComponent } from '../site-header/site-header.component';

@Component({
    selector: 'app-pending-verification',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatButtonModule,
        SiteHeaderComponent
    ],
    templateUrl: './pending-verification.component.html',
    styleUrl: './pending-verification.component.css'
})

export class PendingVerificationComponent extends BaseComponent implements AfterViewInit {

    private _email: WritableSignal<string> = signal("");

    private static _verificationEmailSent = "Verification Email sent";
    private static _sendVerificationEmailError = "Send Verification Email error:";

    public ngAfterViewInit(): void {
        this._email.set(this.stateManager.getUserAccount().email);
    }

    protected get email(): string {
        return this._email();
    }

    protected async continue() {
        this.router.navigate(["/login"]);
    }

    protected async resendVerification() {
        super.message = "";
        const current_user = this.auth.currentUser;

        if (current_user != null) {
            sendEmailVerification(current_user).then(() => {
                super.message = PendingVerificationComponent._verificationEmailSent;

            }).catch((error) => {
                super.message = this.getAuthError(error);
            });
        }
    }

    private getAuthError(error: Error) {
        if (error instanceof FirebaseError) {
            switch (error.code) {
                // Unlike the login page, here within the Pending Verification
                // page/process, the only error we should expect to possibly
                // receive is the "too-many-requests" error.
                case "auth/too-many-requests":
                    return "Temporary error. Too many verification email requests. Please try again in a few minutes."
                default:
                    console.error(`${error.code} - ${error.message}`)
                    return error.code
            }
        } else {
            console.error(`${error.name} - ${error.message}`)
            return error.message;
        }
    }
}
